import React, { useState, useRef, useEffect } from 'react';
import '../styles/bubble.css';
import popSound from '../assets/sfx/bubble-pop.mp3';
import riseSound from '../assets/sfx/bubble-rising.mp3';

export default function Bubble({
  size = '100%',
  className = '',
  children,
  style = {},
  poppable = true,
  spawnOnVisible = true,
  ...props
}) {

  const [popped, setPopped] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [respawning, setRespawning] = useState(false);
  const [spawning, setSpawning] = useState(false);
  const bubbleRef = useRef(null);

  // Intersection Observer for spawn animation
  useEffect(() => {
    if (!spawnOnVisible) return;
    const node = bubbleRef.current;
    if (!node) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpawning(true);
        } else {
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [spawnOnVisible]);

  // Remove spawn class after animation
  useEffect(() => {
    if (!spawning) return;
    const timeout = setTimeout(() => {
      setSpawning(false);
    }, 800);
    return () => clearTimeout(timeout);
  }, [spawning]);

  const bubbleStyle =
    typeof size === 'object'
      ? { ...size, ...style }
      : { width: size, height: size, ...style };

  const handlePop = () => {
    if (!poppable || popped) return;
    const audio = new Audio(popSound);
    audio.play();
    setTimeout(() => {
      setPopped(true);
      setTimeout(() => {
        setRespawning(true);
        setPopped(false);
        const riseAudio = new Audio(riseSound);
        riseAudio.play();
        setTimeout(() => setRespawning(false), 1500);
      }, 2000);
    }, 300);
  };

  const bubbleClass = [
    'bubble',
    className,
    hovered ? 'bubble--hover' : '',
    respawning ? 'bubble--respawn' : '',
    spawning ? 'bubble--spawn' : '',
  ].filter(Boolean).join(' ');

  return (
    <span
      ref={bubbleRef}
      className={bubbleClass}
      style={{
        ...bubbleStyle,
        cursor: poppable ? 'pointer' : undefined,
        visibility: popped ? 'hidden' : 'visible'
      }}
      onClick={poppable ? handlePop : undefined}
      tabIndex={poppable ? 0 : undefined}
      role={poppable ? 'button' : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
    >
      {!popped && children}
    </span>
  );
}